import React from 'react';
import PropTypes from 'prop-types';
import { getIconForCategory } from '../trafficItem/trafficItem';
import { guid } from '../../../ui/src/utilities.js';
import moment from 'moment';

class TrafficGoogleMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.mapEl = null;
    this.map = null;
    this.markers = {};
    this.infoWindows = {};
    this.guid = guid();
    this.guid = this.guid.replace(new RegExp('-', 'g'), '');
    if (typeof window !== 'undefined') {
      window[`onClickInfowindowDetail${this.guid}`] = id => {
        this.onClickDetail(id);
      };
    }


      this.defaultSettingsKe = {
        center: { lat: 48.7164, lng: 21.2611 },
        zoom: 8,
        scrollwheel: false,
      };

      this.defaultSettingsBa = {
        center: { lat: 48.1283027, lng: 17.1225255 },
        zoom: 12,
        scrollwheel: false,
      };


  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.google.maps.event.addDomListener(window, 'load', () => {
        this.map = new window.google.maps.Map(this.mapEl, this.props.region === 'ke'? this.defaultSettingsKe : this.defaultSettingsBa);
        this.fitAllMarkers();
      });
    }
    this.map = new window.google.maps.Map(this.mapEl, this.props.region === 'ke'? this.defaultSettingsKe : this.defaultSettingsBa);
    for (let marker of this.props.markers) {
      this.addMarker(marker);
    }
  }

  fitAllMarkers() {
    if (this.props.markers.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      Object.keys(this.markers).map(id => {
        this.markers[id].setMap(this.map);
        bounds.extend(this.markers[id].getPosition());
        // Default marker for debugging position of custom marker
        // new google.maps.Marker({
        //     position: this.markers[id].getPosition(),
        //     map: this.map,
        // });
        return true;
      });
      this.map.fitBounds(bounds);
      if (this.props.markers.length === 1) {
        this.map.setZoom(15);
      }
    } else {
      if(this.props.region === 'ke'){
        this.map.setZoom(14);
        this.map.setCenter({ lat: 48.704996, lng: 21.243059 });
      } else {
        this.map.setZoom(12);
        this.map.setCenter({ lat: 48.1283027, lng: 17.1225255 });
      }

    }
  }

  onClickDetail(id) {
    if (id in this.markers) {
      if (id in this.infoWindows) {
        this.infoWindows[id].close();
      }
      this.props.onClickDetail(id);
    } else {
      throw `Marker with id "${id}" does not exists!`; // eslint-disable-line no-throw-literal
    }
  }

  addMarker(marker) {
    this.markers[marker._id] = new window.google.maps.Marker({
      position: {
        lat: Number(marker.location.lat),
        lng: Number(marker.location.lon),
      },
      icon: {
        url: getIconForCategory(
          marker.category,
          this.props.activeMarkerId === marker._id,
        ),
        scaledSize: new window.google.maps.Size(
          30,
          this.props.activeMarkerId === marker._id ? 37.5 : 30,
        ),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(
          15,
          this.props.activeMarkerId === marker._id ? 37.5 : 15,
        ),
      },
      map: this.map,
      title: marker.title,
    });
    this.markers[marker._id].addListener('click', () => {
      Object.keys(this.infoWindows).map(key => {
        this.infoWindows[key].close();
        return true;
      });
      this.infoWindows[marker._id] = new window.google.maps.InfoWindow({
        content: `
                            <strong>${marker.title}</strong>
                            <br /> 
                            <em>${
                              marker.description ? marker.description : ''
                            }</em>
                            <br />
                            ${moment(marker.created_date).fromNow()}
                            <br />
                            <a href="javascript:;" class="text-primary" onclick="${`onClickInfowindowDetail${
                              this.guid
                            }`}('${marker._id}')"><strong>VIAC</strong></a>
                        `,
      });
      this.infoWindows[marker._id].open(this.map, this.markers[marker._id]);
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.center &&
      JSON.stringify(nextProps.center) !== JSON.stringify(this.props.center)
    ) {
      this.map.panTo(nextProps.center);
      this.map.setZoom(17);
    } else if (nextProps.center === null) {
      this.fitAllMarkers();
    }

    let newMarkerIds = {};
    for (let marker of nextProps.markers) {
      newMarkerIds[marker._id] = null;
      if (!(marker._id in this.markers)) {
        this.addMarker(marker);
      }
    }

    // diff markers
    Object.keys(this.markers).map(id => {
      if (!(id in newMarkerIds)) {
        this.markers[id].setMap(null);
        delete this.infoWindows[id];
        delete this.markers[id];
      }
      return true;
    });

    this.fitAllMarkers();
  }

  render() {
    return (
      <div
        id="map_canvas"
        style={{ width: '100%', height: '400px' }}
        ref={el => (this.mapEl = el)}
      />
    );
  }
}

TrafficGoogleMap.defaultProps = {
  onClickDetail: () => {},
};

TrafficGoogleMap.propTypes = {
  markers: PropTypes.array.isRequired,
  onClickDetail: PropTypes.func.isRequired,
  center: PropTypes.object,
  activeMarkerId: PropTypes.string,
};

export default TrafficGoogleMap;



// WEBPACK FOOTER //
// ./src/app/component/trafficGoogleMap/trafficGoogleMap.js